export default "__VITE_ASSET__BVoUFAM8__"